import React from 'react';
import styled from 'styled-components';
import { selectLocalizedEventName } from 'models/virtual_event';
import ReactHtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import useNameByLocale from 'hooks/useNameByLocale';
import { useTranslation } from 'react-i18next';

const GreetingTitleContainer = styled.div`
  margin-bottom: 16px;
  font-weight: bold;
  font-size: 1.2rem;
  margin-top: 16px;
`;

const WelcomeMessage = styled.div`
  margin-top: 8px;
  word-break: break-word;
`;

const GreetingTitle = () => {
  const eventName = useSelector(selectLocalizedEventName);
  const name = useNameByLocale();
  const { t } = useTranslation();

  return (
    <GreetingTitleContainer id="profile-picture-greeting-container">
      <div id="profile-picture-greeting">
        {t('greeting', 'Hi, %{name}', { name })}
      </div>
      <WelcomeMessage id="profile-picture-welcome-message">
        {ReactHtmlParser(t('event_welcome_message', { event_name: eventName }))}
      </WelcomeMessage>
    </GreetingTitleContainer>
  );
};

export default GreetingTitle;
